import { isArray } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { HorizontalSeparator } from '../separator';
import { handleEnterKeyUp } from '../../services/accessibility';
import styles from './action-button.scss';

const ActionButton = ({ className, onClick, children }) => {
  const icon = isArray(children) ? children[0] : null;
  const text = isArray(children) ? children[1] : children;
  const rest = isArray(children) ? children.slice(2) : null;

  return (
    <div
      onClick={onClick}
      onKeyUp={handleEnterKeyUp(onClick)}
      className={classNames(styles.actionItem, className, 'action-button')}
      role="menuitem"
      tabIndex="0"
      data-hook="action-button"
    >
      <div className={styles.actionWrapper}>
        {icon && <div className={styles.icon}>{icon}</div>}
        <div className={classNames(styles.actionText, 'blog-text-color', 'action-button__text')}>{text}</div>
        {rest}
      </div>
      <div className={styles.separator}>
        <HorizontalSeparator/>
      </div>
    </div>
  );
};

ActionButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
};

export default ActionButton;



// WEBPACK FOOTER //
// ./app/components/action-button/action-button.js